import LandingPage from "../LandingPage.jsx";

export default function LandingPl() {
  return <LandingPage forcedLang="pl" />;
}